import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from './constants';
import { setCurrentFolderId, unsetCurrentFolderId, setCurrentTierId, unsetCurrentTierId, changeCurrentMediaSource, replaceSelect, toggleAppendSelect, deselect, deselectAll, deselectMulti, setSearchInput, setSearchQuery, unsetSearchQuery, unsetSearchInput, initMediaPopup, setCurrentSubfolderId, unsetCurrentSubfolderId, showNewFolderPopup, hideNewFolderPopup, showAddDeviationsPopup, hideAddDeviationsPopup } from './actions';
import { getDeviationEntityId, getDeviationEntityIds } from '../redux/normalizr/schemas/deviation';
import { handleActions } from 'redux-actions';
const defaultState = {
    searchInput: '',
    selectedDeviationEntityIds: [],
    allowGifs: true,
    allowPremium: false,
    allowInTierContent: false,
    allowMature: true,
    allowUploads: true,
    allowMultipleUploads: true,
    isShowingNewGallectionPopup: false,
    isShowingAddDeviationsPopup: false
};
var _action_payload_allowGifs, _action_payload_allowPremium, _action_payload_allowInTierContent, _action_payload_allowMature, _action_payload_allowUploads, _action_payload_allowMultipleUploads, _action_payload_mediaSourceTypes, _action_payload_withMediaSourceSelector, _action_payload_withNewGallectionPopupOpen, _action_payload_withAddDeviationsPopupOpen;
const actionHandlers = handleActions({
    [initMediaPopup.toString()]: (state, action)=>{
        var _action_payload_gallectionFolder, _action_payload_tier;
        return _object_spread_props(_object_spread({}, state), {
            mode: action.payload.mode,
            currentFolderId: (_action_payload_gallectionFolder = action.payload.gallectionFolder) === null || _action_payload_gallectionFolder === void 0 ? void 0 : _action_payload_gallectionFolder.folderId,
            currentTierId: (_action_payload_tier = action.payload.tier) === null || _action_payload_tier === void 0 ? void 0 : _action_payload_tier.deviationId,
            currentMediaSource: action.payload.mediaSource,
            selectionLimit: action.payload.selectionLimit,
            allowedDeviationTypes: action.payload.allowedDeviationTypes,
            allowedDeviationResourceTypes: action.payload.allowedDeviationResourceTypes,
            allowGifs: (_action_payload_allowGifs = action.payload.allowGifs) !== null && _action_payload_allowGifs !== void 0 ? _action_payload_allowGifs : state.allowGifs,
            allowPremium: (_action_payload_allowPremium = action.payload.allowPremium) !== null && _action_payload_allowPremium !== void 0 ? _action_payload_allowPremium : state.allowPremium,
            allowInTierContent: (_action_payload_allowInTierContent = action.payload.allowInTierContent) !== null && _action_payload_allowInTierContent !== void 0 ? _action_payload_allowInTierContent : state.allowInTierContent,
            allowMature: (_action_payload_allowMature = action.payload.allowMature) !== null && _action_payload_allowMature !== void 0 ? _action_payload_allowMature : state.allowMature,
            allowUploads: (_action_payload_allowUploads = action.payload.allowUploads) !== null && _action_payload_allowUploads !== void 0 ? _action_payload_allowUploads : state.allowUploads,
            allowMultipleUploads: (_action_payload_allowMultipleUploads = action.payload.allowMultipleUploads) !== null && _action_payload_allowMultipleUploads !== void 0 ? _action_payload_allowMultipleUploads : state.allowMultipleUploads,
            ignoreDeviationIds: action.payload.ignoreDeviationIds,
            minDeviationWidth: action.payload.minDeviationWidth,
            minDeviationHeight: action.payload.minDeviationHeight,
            mediaSourceTypes: (_action_payload_mediaSourceTypes = action.payload.mediaSourceTypes) !== null && _action_payload_mediaSourceTypes !== void 0 ? _action_payload_mediaSourceTypes : state.mediaSourceTypes,
            withMediaSourceSelector: (_action_payload_withMediaSourceSelector = action.payload.withMediaSourceSelector) !== null && _action_payload_withMediaSourceSelector !== void 0 ? _action_payload_withMediaSourceSelector : state.withMediaSourceSelector,
            isShowingNewGallectionPopup: (_action_payload_withNewGallectionPopupOpen = action.payload.withNewGallectionPopupOpen) !== null && _action_payload_withNewGallectionPopupOpen !== void 0 ? _action_payload_withNewGallectionPopupOpen : state.isShowingNewGallectionPopup,
            isShowingAddDeviationsPopup: (_action_payload_withAddDeviationsPopupOpen = action.payload.withAddDeviationsPopupOpen) !== null && _action_payload_withAddDeviationsPopupOpen !== void 0 ? _action_payload_withAddDeviationsPopupOpen : state.isShowingNewGallectionPopup,
            gruser: action.payload.gruser
        });
    },
    [showNewFolderPopup.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isShowingNewGallectionPopup: true
        }),
    [hideNewFolderPopup.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isShowingNewGallectionPopup: false
        }),
    [showAddDeviationsPopup.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isShowingAddDeviationsPopup: true
        }),
    [hideAddDeviationsPopup.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            isShowingAddDeviationsPopup: false
        }),
    [setCurrentFolderId.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            currentFolderId: action.payload
        }),
    [unsetCurrentFolderId.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            currentFolderId: undefined
        }),
    [setCurrentSubfolderId.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            currentSubfolderId: action.payload
        }),
    [unsetCurrentSubfolderId.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            currentSubfolderId: undefined
        }),
    [setCurrentTierId.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            currentTierId: action.payload
        }),
    [unsetCurrentTierId.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            currentTierId: undefined
        }),
    [changeCurrentMediaSource.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            currentMediaSource: action.payload
        }),
    [setSearchInput.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            searchInput: action.payload
        }),
    [unsetSearchInput.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            searchInput: ''
        }),
    [setSearchQuery.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            searchQuery: action.payload
        }),
    [unsetSearchQuery.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            searchQuery: undefined
        }),
    [replaceSelect.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            selectedDeviationEntityIds: [
                getDeviationEntityId(action.payload)
            ]
        }),
    [toggleAppendSelect.toString()]: (state, action)=>{
        const { selectedDeviationEntityIds } = state;
        const id = getDeviationEntityId(action.payload);
        const isSelected = selectedDeviationEntityIds.includes(id);
        let updatedSelectedDeviationEntityIds;
        if (isSelected) {
            updatedSelectedDeviationEntityIds = selectedDeviationEntityIds.filter((entityId)=>entityId !== id);
        } else {
            updatedSelectedDeviationEntityIds = [
                ...selectedDeviationEntityIds,
                id
            ];
        }
        return _object_spread_props(_object_spread({}, state), {
            selectedDeviationEntityIds: updatedSelectedDeviationEntityIds
        });
    },
    [deselect.toString()]: (state, action)=>{
        const id = getDeviationEntityId(action.payload);
        return _object_spread_props(_object_spread({}, state), {
            selectedDeviationEntityIds: state.selectedDeviationEntityIds.filter((entityId)=>entityId !== id)
        });
    },
    [deselectMulti.toString()]: (state, action)=>{
        const ids = getDeviationEntityIds(action.payload);
        return _object_spread_props(_object_spread({}, state), {
            selectedDeviationEntityIds: state.selectedDeviationEntityIds.filter((entityId)=>!ids.includes(entityId))
        });
    },
    [deselectAll.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            selectedDeviationEntityIds: []
        })
}, defaultState);
const reducers = {
    [reduxKey]: actionHandlers
};
export default reducers;
